import { Fragment } from "react";
import { HashRouter as Router } from "react-router-dom";
import { logger, registerFormatters } from "cayo.ui";
import { initWizards } from "cayo.ui.wizards";
import "url-polyfill";
import "../../polyfill";
import { testAdminConnection } from "@cayo/admin-components";
import { testGuardianConnection } from "@cayo/guardian-components";
import { testSharedConnection } from "@cayo/shared";
import { endpoints } from "@cayo/shared/services/endpoints.service";
import LocalizedApp from "./LocalizedApp";
import { useDebugStuff } from "./useDebugStuff";
import { durationMinutes } from "../../scheme/formatters/custom-duration-formatter";
import { multilineFormatter } from "../../scheme/formatters/multi-line-formatter";
import { sidToString } from "../../scheme/formatters/sid-formatter";
import globalHooks from "../GlobalHooks";
import MessageProvider from "../Localization/MessageProvider";

initWizards({ PUBLIC_URL: endpoints.publicUrl, REDIRECT_URI: endpoints.redirectUri });

registerFormatters({
  sid: sidToString,
  durationMinutes: durationMinutes as any,
  multiline: multilineFormatter,
});
const log = logger.getLogger("CollectActionParametersDialog");

const isIFrame = window.self !== window.top;

if (process.env.NODE_ENV === "development") {
  log.info("Testing admin components connection:", testAdminConnection());
  log.info("Testing shared connection:", testSharedConnection());
  log.info("Testing guardian components connection:", testGuardianConnection());
}

const App = () => {
  const { userSettings } = globalHooks.useUserSettings();

  useDebugStuff();

  if (isIFrame) {
    return <Fragment />;
  }

  return (
    <MessageProvider lang={userSettings.lang!}>
      <Router>
        <LocalizedApp />
      </Router>
    </MessageProvider>
  );
};

export default App;
